import {
  createStyles, Theme,
} from '@material-ui/core/styles';

const styles = (theme: Theme) => createStyles({
  title: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    minWidth: 'fit-content',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down(600)]: {
      fontSize: '1rem',
    },
    // Скрываем заголовок на мобильных
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  // Спейсеры для центрирования даты на больших экранах
  spacerLeft: {
    flex: '1 1 0%',
    minWidth: 0,
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  spacerRight: {
    flex: '1 1 0%',
    minWidth: 0,
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  datePickerWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    // Верстка для экранов ниже 600px
    [theme.breakpoints.down(600)]: {
      flexShrink: 1, // Позволяем сжиматься
      justifyContent: 'flex-start',
      marginLeft: 0,
      marginRight: theme.spacing(0.5),
      minWidth: 0, // Позволяем сжиматься до минимума
    },
  },
  btnWrap: {
    width: 60,
    height: 60,
    position: 'fixed',
    bottom: 24,
    right: 24,
  },
  leftIcon: {
    marginRight: 21,
  },
  settingsIcon: {
    width: 24,
    height: 24,
    objectFit: 'contain',
    opacity: 0.54,
    cursor: 'pointer',
  },
  // Верстка для экранов выше 600px
  filter: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
    flexShrink: 0,
    '& .MuiTypography-caption': {
      lineHeight: 1.4,
      flexShrink: 0,
      textAlign: 'right',
      marginRight: theme.spacing(1),
      whiteSpace: 'normal', // Разрешаем перенос на 2 строки
      width: 'fit-content', // Ширина по содержимому
      // Уменьшаем размер шрифта при сужении экрана
      fontSize: '0.75rem',
      [theme.breakpoints.down(960)]: {
        fontSize: '0.7rem',
      },
      [theme.breakpoints.down(700)]: {
        fontSize: '0.65rem',
      },
    },
    // Верстка для экранов ниже 600px
    [theme.breakpoints.down(600)]: {
      width: 'auto',
      justifyContent: 'flex-end',
      marginTop: 0,
      marginLeft: 'auto', // Отталкиваемся от даты, прижимаемся к правому краю
      gap: theme.spacing(0.25), // Минимальный gap
      flexShrink: 0,
      '& .MuiTypography-caption': {
        fontSize: '0.65rem', // Еще меньше шрифт
        marginRight: theme.spacing(0.25),
        whiteSpace: 'nowrap',
        flexShrink: 0,
      },
      // Уменьшаем переключатель
      '& .MuiSwitch-root': {
        width: 32, // Еще меньше
        height: 18,
        padding: 0,
        '& .MuiSwitch-switchBase': {
          padding: 1,
          '&.Mui-checked': {
            transform: 'translateX(14px)',
          },
          '& .MuiSwitch-thumb': {
            width: 16,
            height: 16,
          },
        },
        '& .MuiSwitch-track': {
          borderRadius: 9,
          height: 18,
        },
      },
      '& .MuiIconButton-root': {
        padding: 4, // Еще меньше padding
        flexShrink: 0,
        '& svg': {
          fontSize: 16, // Еще меньше иконка
        },
      },
    },
  },
});

export default styles;
